import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { searchAPI } from '../../services/api';
import { User, Opportunity } from '../../types';

interface SearchState {
  users: User[];
  opportunities: Opportunity[];
  loading: boolean;
  error: string | null;
}

const initialState: SearchState = {
  users: [],
  opportunities: [],
  loading: false,
  error: null,
};

export const searchUsers = createAsyncThunk(
  'search/searchUsers',
  async (searchData: any, { rejectWithValue }) => {
    try {
      const response = await searchAPI.search({ ...searchData, type: 'users' });
      const rawUsers = response.data.data.users || [];
      return rawUsers.filter(
        (u: any) => !u.is_disabled && !u.deletion_scheduled_at && !u.deleted_at
      );
    } catch (error: any) {
        // console.log(error)
      return rejectWithValue(error.response?.data?.error || 'Search failed');
    }
  }
);

export const searchOpportunities = createAsyncThunk(
  'search/searchOpportunities',
  async (searchData: any, { rejectWithValue }) => {
    try {
      const response = await searchAPI.search({ ...searchData, type: 'opportunities' });
      return response.data.data.opportunities || [];
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.error || 'Search failed');
    }
  }
);

const searchSlice = createSlice({
  name: 'search',
  initialState,
  reducers: {
    clearSearch: (state) => {
      state.users = [];
      state.opportunities = [];
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(searchUsers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(searchUsers.fulfilled, (state, action) => {
        state.loading = false;
        state.users = action.payload;
      })
      .addCase(searchUsers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(searchOpportunities.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(searchOpportunities.fulfilled, (state, action) => {
        state.loading = false;
        state.opportunities = action.payload;
      })
      .addCase(searchOpportunities.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export const { clearSearch } = searchSlice.actions;
export default searchSlice.reducer;
